import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  InputBase,
  Menu,
  Modal,
  Skeleton,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import TopBarChatContactWindow from "./TopBarChatContactWindow";
import { ChatMessageWindowWrapper } from "../style";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import { CHATSOCKETURL } from "../../../config";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import EmojiPicker from "emoji-picker-react";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";
import {
  useFirstName,
  useInvoffUserid,
  useLastName,
} from "../../../hooks/useLocalStorage";
import { showSuccessMessage } from "../../../components/presentation/common/snackbar";
import { getColorProfile } from "../../../utils/getColorProfile";
import {
  getChatMessages,
  getForwardChatConversation,
  sendChatRequest,
} from "../../../actions/chat";
import { debounce } from "lodash";
import { DEBOUNCE_TIME } from "../../../utils/constants";
import { userTypes } from "../../../utils/ChatUserTypes";
import InfiniteScroll from "react-infinite-scroll-component";
import NoDataLabel from "../../../components/NoDataLabel";
import ReactLinkify from "react-linkify";
import CircularProgress from "@mui/material/CircularProgress";

// import useLocalization from "../../../hooks/useLocalization";

const ContactChatWindow = ({
  isWinBig,
  handleCloseChatWindowChild,
  selectedContact,
  setChatRequestData,
  tabValue,
}) => {
  const dispatch = useDispatch();
  // const { t } = useLocalization("chat");
  const themebody = useTheme()?.palette?.primary;
  const token = sessionStorage.getItem("token");
  const messagesContainerRef = useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { chatRequest } = useSelector((state) => state?.chat);

  const [message, setMessage] = useState("");
  const [socketConnect, setSocketConnect] = useState();
  const [chatReceivedModifiedData, setChatReceivedModifiedData] =
    useState(null);
  const [chatReceivedSeenData, setChatReceivedSeenData] = useState(null);
  const [chatReceivedDeletedData, setChatReceivedDeletedData] = useState(null);
  const [combinedMessageData, setCombinedMessageData] = useState([]); //combiner history and socket message

  const [activeEditMessage, setActiveEditMessage] = useState(null);
  const [activeForwardMessage, setActiveForwardMessage] = useState(null);
  const [openForWardModal, setOpenForWardModal] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);

  const [pageNo, setPageNo] = useState(1);

  const selectedUserProfile = selectedContact?.sender?.profile_pic;
  const selectedUserFirstName = selectedContact?.sender?.first_name;
  const selectedUserLastName = selectedContact?.sender?.last_name;

  const {
    isChatSocketMessageConnected,
    chatMessages: previousMessages,
    getChatMessagesLoading,
  } = useSelector((state) => state.chat);

  const isAdded = selectedContact?.is_added || selectedContact?.participants;

  const firstName = useFirstName();
  const lastName = useLastName();
  const currentUser = useInvoffUserid();
  const currentUserProfileImage = "";

  const handleSendButton = () => {
    if (message?.length > 0 && message?.trim()?.length) {
      setMessage("");
      const receiver =
        selectedContact?.user_detail?.invoffuserid || selectedContact?.userid;
      if (isAdded) {
        const payload = {
          action: "send",
          sender: currentUser,
          text_content: message,
        };
        socketConnect?.send(JSON.stringify(payload));
      } else {
        const payload = {
          receiver,
          request_message: message,
          request_conversation_type: "PRIVATE",
        };
        dispatch(sendChatRequest({ payload }));
        showSuccessMessage(
          `Chat Request Send to ${
            selectedContact?.user_detail?.first_name +
            " " +
            selectedContact?.user_detail?.last_name
          }`
        );
        handleCloseChatWindowChild();
      }
    }
  };

  const handleEditMessage = () => {
    if (
      (activeEditMessage?.id || activeEditMessage?.message_id) &&
      message?.length > 0
    ) {
      const payload = {
        action: "edit",
        sender: activeEditMessage?.sender,
        message_id: activeEditMessage?.id || activeEditMessage?.message_id,
        text_content: message,
      };
      socketConnect?.send(JSON.stringify(payload));
      const updatedMessages = combinedMessageData?.map((item) => {
        if (
          (item?.id || item?.message_id) ===
          (activeEditMessage?.id || activeEditMessage?.message_id)
        ) {
          return {
            ...item,
            text_content: message,
            was_edited: true,
          };
        }
        return item;
      });
      setCombinedMessageData(updatedMessages);
      setMessage("");
      setActiveEditMessage(null);
    }
  };

  useEffect(() => {
    if (activeEditMessage?.id || activeEditMessage?.message_id) {
      setMessage(activeEditMessage?.text_content);
    } else {
      setMessage("");
    }
  }, [activeEditMessage?.id || activeEditMessage?.message_id]);

  const handleDeleteMessage = (chat) => {
    const payload = {
      action: "delete",
      sender: chat?.sender,
      message_id: chat?.id || chat?.message_id,
    };
    if (chat) {
      socketConnect?.send(JSON.stringify(payload));
    }
    const updatedMessages = combinedMessageData?.map((item) => {
      if ((item?.id || item?.message_id) === (chat?.id || chat?.message_id)) {
        return {
          ...item,
          is_active: false,
        };
      }
      return item;
    });
    setCombinedMessageData(updatedMessages);
  };

  const handleForwardMessage = (chat) => {
    setOpenForWardModal(true);
    setActiveForwardMessage(chat);
  };

  useEffect(() => {
    setChatRequestData(chatRequest?.data);
  }, [chatRequest?.data]);

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [combinedMessageData?.length]);

  useEffect(() => {
    if (selectedContact?.id) {
      dispatch(
        getChatMessages({
          conv_id: selectedContact?.id,
          use_pagination: true,
          page: pageNo,
        })
      );
    }
  }, [selectedContact?.id, pageNo]);

  const fetchNextData = () => {
    if (selectedContact?.id && !getChatMessagesLoading) {
      setPageNo((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (selectedContact?.id && previousMessages?.data?.length) {
      setCombinedMessageData(previousMessages?.data);
    }
  }, [previousMessages?.data, selectedContact?.id]);

  //chat socket connect
  useEffect(() => {
    if (!CHATSOCKETURL || !token || !selectedContact?.id) return;

    let newSocket = null;
    let reconnectTimer;
    let attempt = 0;
    let isManuallyClosed = false;

    const getReconnectDelay = (attempt) => {
      const base = Math.min(1000 * 2 ** attempt, 60000);
      const jitter = Math.random() * 1000;
      return base + jitter;
    };

    const connect = () => {
      newSocket = new WebSocket(
        `${CHATSOCKETURL}/ws/chat/${selectedContact?.id}/?token=${token}`
      );
      setSocketConnect(newSocket);
      newSocket.addEventListener("open", () => {
        attempt = 0;
        dispatch({
          type: "IS_CHAT_SOCKET_MESSAGE_CONNECTED",
          details: true,
        });
      });
      newSocket.onerror = (error) => {
        console.warn("error", error);
      };
      newSocket.onclose = (event) => {
        dispatch({
          type: "IS_CHAT_SOCKET_MESSAGE_CONNECTED",
          details: false,
        });
        if (event.wasClean) {
          //
        } else {
          //
        }
        if (!isManuallyClosed) {
          attempt++;
          const delay = getReconnectDelay(attempt);
          reconnectTimer = setTimeout(connect, delay);
        }
      };
      newSocket.addEventListener("error", () => {
        newSocket.close();
      });
    };

    connect();

    return () => {
      isManuallyClosed = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      if (newSocket) {
        newSocket.close();
        dispatch({
          type: "IS_CHAT_SOCKET_MESSAGE_CONNECTED",
          details: false,
        });
      }
    };
  }, [token, selectedContact?.id, CHATSOCKETURL]);

  if (socketConnect) {
    socketConnect.onmessage = (event) => {
      const response = JSON.parse(event.data);
      if (
        response &&
        response?.sender &&
        response?.is_active &&
        !response?.was_edited &&
        !response?.was_seen
      ) {
        setCombinedMessageData((prev) => [response, ...prev]);
      } else if (response?.is_active && response?.was_seen) {
        setChatReceivedSeenData(response);
      } else if (
        response &&
        response?.sender &&
        response?.sender !== currentUser &&
        response?.is_active &&
        response?.was_edited
      ) {
        setChatReceivedModifiedData(response);
      } else if (
        response &&
        response?.sender &&
        response?.sender !== currentUser &&
        !response?.is_active
      ) {
        setChatReceivedDeletedData(response);
      }
    };
  }

  useEffect(() => {
    if (chatReceivedModifiedData && combinedMessageData) {
      const updatedMessages = combinedMessageData?.map((item) => {
        if (
          (item?.id || item?.message_id) ===
          (chatReceivedModifiedData?.id || chatReceivedModifiedData?.message_id)
        ) {
          return {
            ...item,
            text_content: chatReceivedModifiedData?.text_content,
            timestamp: chatReceivedModifiedData?.timestamp,
            was_edited: chatReceivedModifiedData?.was_edited,
          };
        }
        return item;
      });
      setCombinedMessageData(updatedMessages);
    }
  }, [chatReceivedModifiedData]);

  useEffect(() => {
    if (chatReceivedDeletedData && combinedMessageData) {
      const updatedMessages = combinedMessageData?.map((item) => {
        if (
          (item?.id || item?.message_id) ===
          (chatReceivedDeletedData?.id || chatReceivedDeletedData?.message_id)
        ) {
          return {
            ...item,
            is_active: false,
          };
        }
        return item;
      });
      setCombinedMessageData(updatedMessages);
    }
  }, [chatReceivedDeletedData]);

  //setLastMessage
  useEffect(() => {
    if (combinedMessageData?.length > 0) {
      setLastMessage(combinedMessageData[0]);
    }
  }, [combinedMessageData]);

  //send send when modal opens
  useEffect(() => {
    if (
      isChatSocketMessageConnected &&
      lastMessage &&
      lastMessage?.sender !== currentUser
    ) {
      socketConnect?.send(
        JSON.stringify({
          action: "seen",
          message_id: lastMessage?.id || lastMessage?.message_id,
        })
      );
    }
  }, [isChatSocketMessageConnected, lastMessage?.id, lastMessage?.message_id]);

  //seen Data set
  useEffect(() => {
    if (chatReceivedSeenData && combinedMessageData) {
      const updatedMessages = combinedMessageData?.map((item) => {
        if (
          (item?.id || item?.message_id) ===
          (chatReceivedSeenData?.id || chatReceivedSeenData?.message_id)
        ) {
          return {
            ...item,
            updated_at: chatReceivedSeenData?.updated_at,
            status: chatReceivedSeenData?.status,
          };
        }
        return item;
      });
      setCombinedMessageData(updatedMessages);
    }
  }, [chatReceivedSeenData]);

  return (
    <>
      {/* Main Code Area */}
      <ChatMessageWindowWrapper theme={themebody}>
        <TopBarChatContactWindow
          isAdded={isAdded}
          handleCloseChatWindowChild={handleCloseChatWindowChild}
          isWinBig={isWinBig}
          selectedContact={selectedContact ?? {}}
        />
        <Divider />
        <div
          id="scrollableDiv"
          ref={messagesContainerRef}
          style={{
            display: "flex",
            padding: "10px !important",
            gap: "8px",
            paddingLeft: 8,
            paddingTop: 8,
            paddingBottom: 8,
            paddingRight: 8,
            height: "338px",
            overflowY: "auto",
            width: "100%",
            flexDirection: "column-reverse",
          }}
        >
          {!getChatMessagesLoading || combinedMessageData?.length > 0 ? (
            <InfiniteScroll
              loader={
                combinedMessageData?.length > 0 ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress size={20} />
                  </Box>
                ) : (
                  <></>
                )
              }
              scrollThreshold="50px"
              dataLength={combinedMessageData?.length || 0}
              next={fetchNextData}
              hasMore={
                previousMessages?.data?.length !== previousMessages?.count
              }
              scrollableTarget="scrollableDiv"
              inverse={true}
              style={{
                display: "flex",
                flexDirection: "column-reverse",
              }}
            >
              {combinedMessageData?.map((chat) => {
                const isCurrentUserSender =
                  (chat?.sender?.id || chat?.sender) === currentUser;
                const justifyContent = isCurrentUserSender ? "end" : "start";
                return (
                  <div
                    style={{
                      marginTop: "12px",
                    }}
                    key={chat?.id}
                  >
                    {chat?.is_day_first && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          paddingTop: "4px",
                          paddingBottom: "4px",
                        }}
                      >
                        <div
                          style={{
                            flex: "1 1",
                            margin: "auto",
                            border: "0.5px solid #f5f5f5",
                          }}
                        ></div>
                        <Typography
                          sx={{
                            margin: "0 10px",
                            fontSize: "0.8rem",
                            fontFamily: themebody?.textColor,
                          }}
                        >
                          {moment.utc(chat?.created_at).format("DD MMM h:mm A")}
                        </Typography>
                        <div
                          style={{
                            flex: "1 1",
                            margin: "auto",
                            border: "0.5px solid #f5f5f5",
                          }}
                        ></div>
                      </div>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: justifyContent,
                        maxWidth: "50%",
                        alignItems: "start",
                        marginLeft: isCurrentUserSender && "auto",
                        gap: 1,
                      }}
                    >
                      <Box sx={{ flexShrink: 0 }}>
                        {!isCurrentUserSender && (
                          <Avatar
                            variant="contained"
                            alt={
                              selectedUserFirstName?.[0] +
                              selectedUserLastName?.[0]
                            }
                            src={
                              selectedUserProfile !== "undefined" &&
                              `${selectedUserProfile}`
                            }
                            sx={{
                              fontSize: "14px",
                              width: "30px",
                              height: "30px",
                              background: getColorProfile({
                                firstName: selectedUserFirstName,
                                lastName: selectedUserLastName,
                              }),
                            }}
                          >
                            {selectedUserFirstName?.[0]?.toUpperCase() +
                              selectedUserLastName?.[0]?.toUpperCase()}
                          </Avatar>
                        )}
                      </Box>
                      {chat?.is_active ? (
                        <ChatTooltip
                          messagesContainerRef={messagesContainerRef}
                          chat={chat}
                          isCurrentUserSender={isCurrentUserSender}
                          setActiveEditMessage={setActiveEditMessage}
                          handleDeleteMessage={handleDeleteMessage}
                          handleForwardMessage={handleForwardMessage}
                        />
                      ) : (
                        <Box
                          sx={{
                            background: themebody?.lightGrey,
                            borderRadius: "12px",
                            p: "10px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.8rem",
                              fontStyle: "italic",
                            }}
                          >
                            {"Message"} {"Deleted"}
                          </Typography>
                        </Box>
                      )}
                      <Box sx={{ flexShrink: 0 }}>
                        {isCurrentUserSender && (
                          <Avatar
                            variant="contained"
                            alt={firstName?.[0] + lastName?.[0]}
                            src={
                              currentUserProfileImage !== "undefined" &&
                              `${currentUserProfileImage}`
                            }
                            sx={{
                              fontSize: "14px",
                              width: "30px",
                              height: "30px",
                              background: getColorProfile({
                                firstName: firstName,
                                lastName: lastName,
                              }),
                            }}
                          >
                            {firstName?.[0]?.toUpperCase() +
                              lastName?.[0]?.toUpperCase()}
                          </Avatar>
                        )}
                      </Box>
                    </Box>
                  </div>
                );
              })}
            </InfiniteScroll>
          ) : (
            [0, 1, 2, 3, 4, 5, 6, 7, 8].map((item, idx) => {
              const isCurrentUserSender = item % 2 === 0;
              const justifyContent = isCurrentUserSender ? "end" : "start";
              return (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    justifyContent,
                    maxWidth: "100%",
                    alignItems: "center",
                    marginLeft: isCurrentUserSender && "auto",
                    gap: 1,
                  }}
                >
                  <Box sx={{ flexShrink: 0 }}>
                    {!isCurrentUserSender && (
                      <Avatar sx={{ width: "32px", height: "32px" }} />
                    )}
                  </Box>
                  <Skeleton sx={{ width: "200px" }} animation="wave" />
                  <Box sx={{ flexShrink: 0 }}>
                    {isCurrentUserSender && (
                      <Avatar sx={{ width: "32px", height: "32px" }} />
                    )}
                  </Box>
                </Box>
              );
            })
          )}
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            activeEditMessage?.id || activeEditMessage?.message_id
              ? handleEditMessage()
              : handleSendButton();
          }}
          style={{
            bottom: 0,
            position: "relative",
            width: "100%",
            paddingBottom: "4px",
            paddingLeft: "8px",
            paddingRight: "8px",
          }}
        >
          {(activeEditMessage?.id || activeEditMessage?.message_id) && (
            <Typography
              sx={{
                fontSize: "0.6rem",
                marginBottom: "1px",
              }}
            >
              {"Edit"} {"Message"}
            </Typography>
          )}
          <TextField
            autoFocus
            InputProps={{
              disableUnderline: true,
              sx: {
                fontSize: "0.8rem",
              },
            }}
            id="filled-multiline-static"
            placeholder={`Write a message...`}
            sx={{
              padding: "4px",
              color: "#D4D3D2",
              background: "#F0EEEA",
              borderRadius: "8px",
              paddingX: 1,
              paddingRight: 3,
            }}
            multiline
            variant="standard"
            rows={isWinBig ? 4 : 3}
            value={message}
            fullWidth
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                activeEditMessage?.id || activeEditMessage?.message_id
                  ? handleEditMessage()
                  : handleSendButton();
              }
            }}
          />
          <IconButton
            sx={{
              position: "absolute",
              top: {
                xs:
                  activeEditMessage?.id || activeEditMessage?.message_id
                    ? "40px"
                    : "24px",
                md:
                  activeEditMessage?.id || activeEditMessage?.message_id
                    ? "44px"
                    : "28px",
                lg:
                  activeEditMessage?.id || activeEditMessage?.message_id
                    ? "48px"
                    : "32px",
              },
              right: "4px",
            }}
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
          >
            <EmojiEmotionsIcon />
          </IconButton>
          <Menu
            sx={{
              ".css-6hp17o-MuiList-root-MuiMenu-list": {
                paddingTop: "0px !important",
                paddingBottom: "0px !important",
              },
            }}
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <EmojiPicker
              skinTonesDisabled
              height={400}
              onEmojiClick={(emojiObject) => {
                setMessage((prev) => prev + emojiObject.emoji);
                setAnchorEl(null);
              }}
            />
          </Menu>
          <Box
            sx={{
              marginLeft: "auto",
              mt: 1,
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {activeEditMessage && (
              <Button
                type="button"
                variant="outlined"
                className=""
                sx={{
                  borderRadius: "16px",
                }}
                onClick={() => setActiveEditMessage(null)}
              >
                {"Cancel"}
              </Button>
            )}
            <Button
              type="submit"
              disabled={message?.length > 250 ? true : false}
              endIcon={<SendOutlinedIcon />}
              variant="filled"
              className="button-container"
              sx={{
                maxHeight: isWinBig ? "15px" : "10px",
                px: "60px !important",
                py: "18px !important",
              }}
            >
              {activeEditMessage?.id || activeEditMessage?.message_id
                ? "Update"
                : isAdded
                ? "Send"
                : "Request"}
            </Button>
          </Box>
        </form>
      </ChatMessageWindowWrapper>
      <Modal
        open={openForWardModal}
        onClose={() => setOpenForWardModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 2,
            right: {
              xs: 5,
              sm: 420,
              md: 650,
              lg: 800,
            },
            bgcolor: themebody?.whitecolor,
            borderRadius: 3,
            border: "none",
            width: "320px",
          }}
        >
          <ForwardMessageModal
            selectedContact={selectedContact}
            activeForwardMessage={activeForwardMessage}
            setOpenForWardModal={setOpenForWardModal}
            tabValue={tabValue}
            socketConnect={socketConnect}
          />
        </Box>
      </Modal>
    </>
  );
};

export default ContactChatWindow;

const debouncedSearch = debounce(({ setDebounceKeyword, value }) => {
  setDebounceKeyword(value);
}, DEBOUNCE_TIME);

export const ForwardMessageModal = ({
  tabValue,
  setOpenForWardModal,
  activeForwardMessage,
  socketConnect,
  selectedContact,
}) => {
  const dispatch = useDispatch();
  // const { t } = useLocalization("chat");
  const themebody = useTheme()?.palette?.primary;
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [debounceKeyword, setDebounceKeyword] = useState("");

  const { forwardchatConversation, forwardchatConversationLoading } =
    useSelector((state) => state.chat);

  const handleToggle = (id) => {
    setSelectedUsers((prevSelectedUsers) =>
      prevSelectedUsers.includes(id)
        ? prevSelectedUsers.filter((userId) => userId !== id)
        : [...prevSelectedUsers, id]
    );
  };

  const handleSearchContact = (e) => {
    const value = e.target.value;
    setSearchUser(value);
    debouncedSearch({
      setDebounceKeyword,
      value,
    });
  };

  useEffect(() => {
    dispatch(
      getForwardChatConversation({
        userType: userTypes?.[tabValue],
        name: debounceKeyword,
      })
    );
  }, [tabValue, debounceKeyword]);

  const handleForwardMessage = () => {
    if (selectedUsers && selectedUsers?.length) {
      const payload = {
        action: "forward",
        sender: activeForwardMessage?.sender,
        message_id:
          activeForwardMessage?.id || activeForwardMessage?.message_id,
        forward_to: selectedUsers,
      };
      socketConnect?.send(JSON.stringify(payload));
      setSelectedUsers([]);
      setSearchUser("");
      setDebounceKeyword("");
      setOpenForWardModal(false);
    }
  };

  const renderLoader = (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        px: 1,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginTop: "6px",
      }}
    >
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
      <Skeleton height="40px" animation="wave" />
    </Box>
  );

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "auto",
        height: "500px",
        marginTop: "4px",
        paddingX: "10px",
      }}
    >
      {" "}
      <ChatMessageWindowWrapper theme={themebody}>
        {/* <ChatMessageWindowWrapper theme={themebody}> */}
        <Box
          sx={{
            // background: themebody?.colors?.whitecolor,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2">
              {"Forward"} {"Message"}
            </Typography>
          </Box>
          <IconButton
            onClick={() => {
              setOpenForWardModal(false);
              setSelectedUsers([]);
              setSearchUser("");
              setDebounceKeyword("");
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box
          component="form"
          sx={{
            display: "flex",
            alignItems: "center",
            mt: 1,
            background: "#EEF3F7",
            borderRadius: "4px",
          }}
        >
          <IconButton
            type="button"
            sx={{ paddingY: "8px" }}
            aria-label="search"
          >
            <SearchIcon fontSize="small" />
          </IconButton>
          <InputBase
            value={searchUser}
            onChange={handleSearchContact}
            sx={{ ml: 0.5, flex: 1, fontSize: "14px" }}
            placeholder="Search"
            inputProps={{ "aria-label": "search" }}
          />
          {/* <IconButtons sx={{ paddingY: "8px" }} aria-label="menu">
            <TuneIcon fontSize="small" />
          </IconButtons> */}
        </Box>
        <Typography
          sx={{
            // color: themebody?.colors?.textcolor,
            fontSize: "14px",
            marginTop: "10px",
          }}
        >
          {"Suggested"}
        </Typography>
        <div
          style={{
            minHeight: "330px",
            overflowY: "auto",
          }}
        >
          {forwardchatConversationLoading ? (
            renderLoader
          ) : forwardchatConversation &&
            forwardchatConversation?.filter(
              (item) => item?.id !== selectedContact?.id
            ).length !== 0 ? (
            forwardchatConversation
              ?.slice(0, 5)
              ?.filter((item) => item?.id !== selectedContact?.id)
              ?.map((request) => {
                const {
                  sender: {
                    first_name = "",
                    last_name = "",
                    profile_pic = "",
                  } = {},
                } = request ?? {};
                const fullName = `${first_name} ${last_name}`;
                return (
                  <Box
                    sx={{
                      mt: 2,
                      cursor: "pointer",
                    }}
                    key={request?.id}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        width: "100%",
                      }}
                    >
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                padding: "0px !important",
                                paddingLeft: "10px !important",
                                ".css-j204z7-MuiFormControlLabel-root": {
                                  marginRight: "0px !important",
                                },
                              }}
                              checked={selectedUsers.includes(request.id)}
                              onChange={() => handleToggle(request.id)}
                            />
                          }
                        />
                      </div>
                      <Box flexShrink={0}>
                        <Avatar
                          variant="contained"
                          alt={fullName?.[0]}
                          src={profile_pic !== "undefined" && `${profile_pic}`}
                          sx={{
                            fontSize: "14px",
                            width: "28px",
                            height: "28px",
                            background: getColorProfile({
                              firstName: fullName?.[0],
                              lastName: last_name?.[0],
                            }),
                          }}
                        >
                          {fullName?.[0]?.toUpperCase() +
                            last_name?.[0]?.toUpperCase()}
                        </Avatar>
                        {/* <RenderProfileImage
                          size="28px"
                          fontsize=""
                          imageUrl={profile_pic}
                          firstCharacter={fullName?.[0] + last_name?.[0]}
                        /> */}
                      </Box>
                      <Box sx={{ width: "100%" }}>
                        <Typography
                          sx={{
                            fontSize: "0.8rem",
                          }}
                        >
                          {fullName}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        height: "1.5px",
                        width: "96%",
                        mt: "6px",
                        // background: themebody?.colors?.graycolor,
                      }}
                    ></Box>
                  </Box>
                );
              })
          ) : (
            <Box mt={2}>
              <Typography>
                <NoDataLabel />
              </Typography>

              {/* <Typography>
                <NoDataLabel />
              </Typography> */}
            </Box>
          )}
        </div>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            gap: "10px",
          }}
          mt={2}
        >
          <Button
            variant="outlined"
            className=""
            sx={{
              borderRadius: "16px",
            }}
            onClick={() => {
              setSelectedUsers([]);
              setSearchUser("");
              setDebounceKeyword("");
              setOpenForWardModal(false);
            }}
          >
            {"Cancel"}
          </Button>
          <Button
            type="button"
            onClick={handleForwardMessage}
            endIcon={<SendOutlinedIcon />}
            variant="filled"
            className="button-container"
            sx={{
              fontSize: "13px",
              maxHeight: "10px",
              px: "55px !important",
              py: "18px !important",
            }}
          >
            {"Forward"}
          </Button>
        </Box>
      </ChatMessageWindowWrapper>
    </Box>
  );
};

const ChatTooltip = ({
  chat,
  isCurrentUserSender,
  setActiveEditMessage,
  handleDeleteMessage,
  handleForwardMessage,
  messagesContainerRef,
}) => {
  const themebody = useTheme()?.palette?.primary;
  // const { t } = useLocalization("chat");
  const [openTooltip, setOpenTooltip] = React.useState(false);
  const [canChangeData, setCanChangeData] = React.useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    if (messagesContainerRef.current) {
      setIsScrolled(true);
    }
  };

  useEffect(() => {
    const divElement = messagesContainerRef.current;
    if (divElement) {
      divElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (divElement) {
        divElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (isScrolled) {
      setOpenTooltip(false);
    }
  }, [isScrolled]);

  useEffect(() => {
    if (openTooltip) {
      setIsScrolled(false);
    }
  }, [openTooltip]);

  //disable edit/delete after 90sec
  useEffect(() => {
    if (!chat?.created_at) return;

    const createdAt = Date.parse(chat.created_at);
    if (isNaN(createdAt)) return;

    const now = Date.now();
    const diffSeconds = (now - createdAt) / 1000;

    if (diffSeconds < 90) {
      setCanChangeData(true);
      const remainingTime = 90000 - (now - createdAt);
      const timer = setTimeout(() => setCanChangeData(false), remainingTime);
      return () => clearTimeout(timer);
    } else {
      setCanChangeData(false);
    }
  }, [chat?.created_at]);

  return (
    <Tooltip
      open={openTooltip}
      onClose={() => setOpenTooltip(false)}
      onOpen={() => setOpenTooltip(true)}
      placement="top"
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
              {
                marginTop: "0px",
                background: "white",
                boxShadow: themebody?.boxShadow,
                border: `1px solid ${themebody?.greycolor}`,
              },
            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
              {
                marginBottom: "0px",
                background: "white",
                boxShadow: themebody?.boxShadow,
                border: `1px solid ${themebody?.greycolor}`,
              },
            [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
              {
                marginLeft: "0px",
                background: "white",
                boxShadow: themebody?.boxShadow,
                border: `1px solid ${themebody?.greycolor}`,
              },
            [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
              {
                marginRight: "0px",
                background: "white",
                boxShadow: themebody?.boxShadow,
                border: `1px solid ${themebody?.greycolor}`,
              },
          },
        },
      }}
      title={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {isCurrentUserSender && canChangeData && (
              <IconButton
                onClick={() => setActiveEditMessage(chat)}
                sx={{ padding: "0px" }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            {isCurrentUserSender && canChangeData && (
              <IconButton
                onClick={() => handleDeleteMessage(chat)}
                sx={{ padding: "0px" }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton
              onClick={() => {
                handleForwardMessage(chat);
              }}
              sx={{ padding: "0px" }}
            >
              <ShortcutIcon fontSize="small" />
            </IconButton>
          </div>
        </>
      }
    >
      <Box
        sx={{
          width: "100%",
          background: themebody?.lightGrey,
          borderRadius: "12px",
          p: "6px",
        }}
      >
        <Typography
          sx={{
            fontSize: "0.8rem",
            wordBreak: "break-word",
          }}
        >
          <ReactLinkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <a
                href={decoratedHref}
                key={key}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "underline" }}
              >
                {decoratedText}
              </a>
            )}
          >
            {chat.text_content}
          </ReactLinkify>
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isCurrentUserSender ? "end" : "start",
          marginLeft: isCurrentUserSender ? "0px" : "8px",
          marginRight: isCurrentUserSender ? "8px" : "0px",
        }}
      >
        {chat?.was_forwarded && (
          <div>
            <ShortcutIcon fontSize="small" />
          </div>
        )}
        <Typography
          sx={{
            fontSize: "0.6rem",
            display: "flex",
          }}
        >
          {moment(chat?.updated_at).format("hh:mm:ss A")}
        </Typography>
        {chat?.was_edited && (
          <Typography
            sx={{
              fontSize: "0.6rem",
              display: "flex",
              justifyContent: isCurrentUserSender ? "end" : "start",
            }}
          >
            &#8729; {"Edited"}
          </Typography>
        )}
        {isCurrentUserSender && (
          <Typography
            sx={{
              fontSize: "0.6rem",
              display: "flex",
              justifyContent: isCurrentUserSender ? "end" : "start",
            }}
          >
            &#8729;
            {chat?.status}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};
